export function clamp(v: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, v));
}

export function sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}
